<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xml:space="preserve"
    width="27.8795mm"
    height="40.8404mm"
    version="1.1"
    style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
    viewBox="0 0 1192.53 1746.92"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <style type="text/css">
        <![CDATA[
         .fil0 {fill:#373435}
        ]]>
      </style>
    </defs>
    <g id="Camada_x0020_1">
      <metadata id="CorelCorpID_0Corel-Layer" />
      <path
        class="fil0"
        d="M930.81 406.27l0.03 0c143.94,0 261.68,117.74 261.68,261.68l0 817.3c0,143.94 -117.75,261.68 -261.68,261.68l-0.03 0c-143.94,0 -261.68,-117.74 -261.68,-261.68l0 -817.3c0,-143.94 117.75,-261.68 261.68,-261.68zm-669.14 542.47l0.04 0c143.94,0 261.68,117.82 261.68,261.68l0 274.83c0,143.86 -117.81,261.68 -261.68,261.68l-0.04 0c-143.86,0 -261.68,-117.74 -261.68,-261.68l0 -274.83c0,-143.94 117.74,-261.68 261.68,-261.68zm0.43 -406.26c83.13,0 150.55,67.41 150.55,150.54 0,83.13 -67.42,150.55 -150.55,150.55 -83.13,0 -150.54,-67.42 -150.54,-150.55 0,-83.13 67.42,-150.54 150.54,-150.54zm668.45 -542.47c83.13,0 150.55,67.42 150.55,150.55 0,83.13 -67.42,150.55 -150.55,150.55 -83.13,0 -150.55,-67.42 -150.55,-150.55 0,-83.13 67.42,-150.55 150.55,-150.55z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IcoCoaching',
}
</script>
